import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';
import * as Hammer from 'hammerjs';

@Injectable()
export class HammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { enable: false },
    pinch: { enable: false },
    rotate: { enable: false },
  };
  override events: string[] = [
    'panh',
    'panhstart',
    'panhmove',
    'panhend',
    'panhcancel',
    'panv',
    'panvstart',
    'panvmove',
    'panvend',
    'panvcancel',
  ];
  override buildHammer(el: HTMLElement) {
    const mc = new Hammer.Manager(el, { touchAction: 'pan-y' });
    const panV = new Hammer.Pan({
      event: 'panv',
      direction: Hammer.DIRECTION_VERTICAL,
      threshold: 8,
    });
    const panH = new Hammer.Pan({
      event: 'panh',
      direction: Hammer.DIRECTION_HORIZONTAL,
      threshold: 16,
    });
    mc.add([panV, panH]);
    return mc;
  }
}
